export const SET_VIDEO_CATEGORY = 'VIDEO_CATEGORY/SET_VIDEO_CATEGORY'
export const SET_VIDEO_CATEGORIES = 'VIDEO_CATEGORY/SET_VIDEO_CATEGORIES'
